/* eslint-disable react/require-default-props */
import Loader from 'components/atoms/loader';
import BiddingItem from 'components/molecules/bidding_item';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { BiddingState } from 'store/modules/bidding_store/types';
import TotalEntriesLabel from 'components/atoms/total_entries_label';
import Pagination from 'components/atoms/pagination';
import logoConlicitacao from 'assets/images/logo-conlicita-verde.svg';

interface SharedBiddingListProps {
  setBiddingLoaded: React.Dispatch<React.SetStateAction<boolean>>;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

const SharedBiddingList = (props: SharedBiddingListProps) => {
  const { setBiddingLoaded, currentPage, setCurrentPage } = props;

  const { biddings, request } = useSelector<ApplicationState, BiddingState>(
    (state) => state.session.biddings,
  );

  const componentRef = useRef() as React.MutableRefObject<HTMLInputElement>;

  const updateCurrentPage = (currentPage = 1) => {
    setCurrentPage(currentPage);
  };

  useEffect(() => {
    setBiddingLoaded(request?.get_biddings?.error);
  }, [request?.get_biddings?.error]);

  return (
    <div className="page-container w-100">
      <div className="container p-4">
        {request?.get_biddings?.loading && (
          <div className="d-flex align-items-center justify-content-center loading-container">
            <Loader />
          </div>
        )}
        {request?.get_biddings?.loaded && biddings?.bidding_list?.length > 0 && (
          <div className="row">
            <div className="col-12 p-0">
              <h4 className="font-weight-bold">Compartilhamento de Licitações</h4>
            </div>
            <div className="col-12 d-flex justify-content-end text-secondary p-0">
              <TotalEntriesLabel itemLabel="licitações" totalEntries={biddings.total_entries} />
            </div>

            <div ref={componentRef} className="row mx-1 mt-5">
              <div className="col-12">
                {request?.get_biddings?.loaded &&
                  biddings?.bidding_list?.map((bidding, index) => (
                    <BiddingItem
                      key={bidding.id}
                      bidding={bidding}
                      biddingIndex={index + (currentPage - 1) * 20}
                      isChecked={false}
                      toggleSelected={() => {}}
                      source="share"
                    />
                  ))}
              </div>
            </div>
          </div>
        )}
        {request?.get_biddings?.loaded && biddings.total_entries !== 0 && (
          <div className="row d-print-none">
            <div className="col-12 mx-auto mb-5 pb-5 p-md-0">
              <Pagination
                postsPerPage={20}
                totalPosts={biddings.total_entries}
                paginate={updateCurrentPage}
                currentPage={currentPage || 1}
                firstAndLastPage
              />
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-md-12 p-0">
            <h6 className="font-weight-bold">POLÍTICA DE USO E RESPONSABILIDADE DE CONTEÚDO</h6>
            <p>1) As informações aqui apresentadas não substituem as publicações oficiais.</p>
            <p>
              2) Os serviços de informação prestados pelo ConLicitação se constituem em obrigações
              de meios, independendo do resultado nos certames.
            </p>
            <p>
              3) A exclusividade do uso é restrita à pessoa jurídica identificada no cadastro de
              clientes do ConLicitação, a quem está direcionado o presente, sendo portanto vedado
              aos usuários distribuir, transmitir, exibir, reproduzir ou transferir quaisquer
              informações aqui contidas, exceto dentro do seu meio corporativo.
            </p>
            <p>
              <a href="mailto:apoio@conlicitacao.com.br">apoio@conlicitacao.com.br</a>
            </p>
            <p className="d-flex align-items-center">
              Todos os direitos reservados ©{' '}
              <img className="ml-1" src={logoConlicitacao} height="18px" alt="Logo Conlicitação" />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SharedBiddingList;
